export default {"src":"/_next/static/media/email.cd6f909c.svg","height":57,"width":56,"blurWidth":0,"blurHeight":0};